import React from "react";
import { Item, Title, Description } from "../../common/CommonStyles";
import styled from "styled-components";

export const ClientQuestionRenderer = ({ question, isMatched, t }) => {
  return (
    <Item>
      <QuestionTitle>{t("logs.clientQuestion")}:</QuestionTitle>
      <Description>{question || ""}</Description>
    </Item>
  );
};

const QuestionTitle = styled(Title)`
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 15px;
`;
